module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/aoj_a-3-b2d929ffc735ac36118e2f0ae6cc3364.jpg";